<div class="sd-modal-tooltip">
  <div
    class="sd-modal-tooltip__toast"
    aria-live="polite"
    [class.sd-modal-tooltip__toast--clickable]="tooltipOptions.route"
    (click)="navigateToRoute($event)"
    [attr.tabindex]="tooltipOptions.route ? 0 : null"
    [attr.role]="tooltipOptions.route ? 'button' : null"
  >
    <ng-content></ng-content>
  </div>
</div>
